module.exports = __webpack_public_path__ + "media/images/emblems/Chardonne-coat_of_arms-d57da75c1ef9a86cc5049d20d5f2efef.svg";